import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { CircleUserIcon } from "../../../../assets/icons";
import { ClientProjectAssignmentSummaryDTO } from "../../../../models/client-project-assignment-summary/client-project-assignment-summary-dto";
import CircleAndIconContainer from "../../reusable-widget-link-components/CircleAndIconContainer/CircleAndIconContainer";

const MyTeamAssignedEmployeesLink = ({
  customSummary,
  loading,
}: {
  customSummary: ClientProjectAssignmentSummaryDTO;
  loading: boolean;
}) => {
  const tRP = "components.custom_widget_links.my_team_project_assignments.assigned_employees";
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <CircleAndIconContainer
      // title={`${t(`${tRP}.title`)}`}
      mainInfo={customSummary?.assignedEmployees?.toString() ?? "0"}
      description={`${t(`${tRP}.title`)}`}
      Icon={CircleUserIcon}
      IconStyle={{
        color: theme.palette.success.main,
        width: "90%",
        height: "90%",
      }}
      loading={loading}
    />
  );
};
export default MyTeamAssignedEmployeesLink;
